export const defaultContent = {
  events: [{}, {}, {},],
};

export const themeColors = [  
  {
    hex: '#F3511E',
    name: 'orange',
    label: 'Orange'
  },
  {
    hex: '#5A50CC',
    name: 'purple',
    label: 'Purple'
  },
  {
    hex: '#D8214C',
    name: 'red',
    label: 'Red'
  }
]

export const formatOptions = [
  {
    label: 'Date',
    value: 'date'
  },
  {
    label: 'Date and Time',
    value: 'datetime'
  }
]

export const ampmOptions = [
  {
    label: 'AM',
    value: 'AM'
  },
  {
    label: 'PM',
    value: 'PM'
  }
]